module.exports = __webpack_public_path__ + "static/img/newsir.b4422a31.gif";